import CachedIcon from '@mui/icons-material/Cached';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Stack } from "@mui/material";
import classNames from 'classnames';
import React, { memo, useCallback, useContext, useRef } from "react";
import { DashboardsTableContext } from '../../../../../contexts/TablesContext/DashboardsTableProvider';
import theme from '../../../../../theme';
import useStyles from "../styles";

const SyncStatus: React.FC<{}> = () => {
    const classes = useStyles();
    const { setModalContext } = useContext(DashboardsTableContext);
    const anchorRef = useRef<HTMLDivElement>(null);

    const handleModalOpen = useCallback(() => {
        setModalContext({
            open: 'NavigationModal',
            field: 'Sync Status',
            anchorElement: anchorRef.current,
            onClose: () => setModalContext({}),
        });
    }, [setModalContext]);

    return (
        <Stack direction="row" className={classNames(classes.header, classes.hoverHeader)}
            spacing={1} alignItems="center" justifyContent="flex-start" width="100%" ref={anchorRef}
            onClick={handleModalOpen}>
            <CachedIcon style={{ minWidth: 24, maxWidth: 24, height: 24, stroke: 'rgb(163, 167, 172)', strokeWidth: '0.25' }} />
            <span>{'Sync Status'}</span>
            <ExpandMoreIcon
                sx={{ color: theme.colors.neutral['600'], cursor: 'pointer',
                    "&:hover": { color: theme.colors.neutral['900'] },
                }} />
        </Stack>
    );
}

export default memo(SyncStatus);